const isTradeIn = (product) =>
  product?.deployment === 'N' ||
  product?.deployment === 'network' ||
  product?.deployment === 'Network' ||
  product?.deployment === 'Multi-User';

export default isTradeIn;
